import Joi from 'joi-browser';
import moment from "moment-timezone";

function getListOfTimeZones() {
    let timezones = moment.tz.names();
    timezones = timezones.map(function (t) {
        return {
            value: t,
            key: t
        }
    });
    return timezones;
}
function getDays(start, end) {
    let days = [];
    for (let i = start; i <= end; i++) {
        days.push({
            key: i,
            value: Number(i)
        });
    }
    return days;
}
export function getCompanyConfig() {
    return {
        scope: 'admin',
        actionEdit: true,
        displayName: 'Companies',
        empty: {
            name: "",
            code: "",
            email: "",
            phoneNumber: "",
            address: "",
            size: "",
            managed: false,
            autopay: []
        },
        fieldTypes: {
            id: {
                fieldName: "ID",
                type: 'text',
                required: false,
                category: "hidden"
            },
            name: {
                fieldName: "Name",
                type: 'text',
                required: true,
            },
            code: {
                fieldName: "Code",
                type: 'text',
                required: true
            },
            email: {
                fieldName: "Email",
                type: 'email',
                required: true
            },
            phoneNumber: {
                fieldName: "Phone",
                type: 'tel',
                required: true
            },
            address: {
                fieldName: "Address",
                type: 'text',
                required: true
            },
            timezone: {
                type: 'text',
                fieldName: "Timezone",
                required: true,
                type: "dropdown",
                options: getListOfTimeZones(),
                notes: 'NOTE: Updating timezone will not change existing data'
            },
            size: {
                type: 'text',
                fieldName: "Size (# of employees)"
            },
            FAQ: {
                type: 'text',
                fieldName: "Frequently Asked Questions (URL)",
                required: false
            },
            totalShares: {
                type: 'number',
                fieldName: "Shares Reserved",
                required: false
            },
            autopay: {
                type: 'dropdown',
                fieldName: "Autopay Days",
                required: false,
                options: getDays(1, 30)
            },
            managed: {
                type: 'checkbox',
                fieldName: "Managed"
            },
        },
        validationSchema: Joi.object().keys({
            id: Joi.string(),
            name: Joi.string().required(),
            code: Joi.string().required(),
            email: Joi.string().required(),
            phoneNumber: Joi.string().required(),
            timezone: Joi.string().required(),
            address: Joi.string().required(),
            size: Joi.string().allow('').regex(/^[0-9.,\b]+$/),
            FAQ: Joi.string().uri(),
            totalShares: Joi.number().min(0),
            managed: Joi.boolean().required(),
            autopay: Joi.array().items(Joi.number()),
        }),
        actions: [{
            title: 'Edit',
            action_type: 'edit',
            icon: 'edit'
        },
        {
            title: 'Switch',
            action_type: 'switch',
            icon: 'switch'
        }
        ]
    }
}